'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var _extends = require('@babel/runtime/helpers/extends');
var React = require('react');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var _extends__default = /*#__PURE__*/_interopDefaultLegacy(_extends);
var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

const CheckMark = props => /*#__PURE__*/React__default["default"].createElement("svg", _extends__default["default"]({
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor"
}, props), /*#__PURE__*/React__default["default"].createElement("path", {
  d: "M14.162 3.464a1.103 1.103 0 0 1 1.523 0c.415.402.42 1.05.015 1.457l-8.601 9.7a1.103 1.103 0 0 1-1.549.029L.315 9.59a1.016 1.016 0 0 1 0-1.472 1.103 1.103 0 0 1 1.523 0l4.44 4.292 7.856-8.915a.349.349 0 0 1 .028-.03Z"
}));

exports["default"] = CheckMark;
